import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { passwordResetAPI } from '../../services/api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CornerDownLeft } from 'lucide-react';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultEmail = location.state?.email || '';
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { email: defaultEmail },
  });

  const onSubmit = async ({ email, code, new_password }) => {
    try {
      await passwordResetAPI.confirm(email, code, new_password);
      toast.success('Password reset successfully');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to reset password');
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">Reset Password</h2>
          <p className="mt-2 text-center text-sm text-gray-600 italic">
            Verify your code and set a new password
          </p>
        </div>
        <div className='px-5 pb-5 rounded-3xl border drop-shadow-lg'>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
            <div className="space-y-4">
              <div>
                <label className="form-label" htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  className={`pl-4 form-input ${errors.email ? 'border-red-500' : ''}`}
                  placeholder="you@example.com"
                  {...register('email', { required: 'Email is required' })}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
                )}
              </div>
              <div>
                <label className="form-label" htmlFor="code">Verification code</label>
                <input
                  id="code"
                  type="text"
                  className={`pl-4 form-input ${errors.code ? 'border-red-500' : ''}`}
                  placeholder="6-digit code"
                  {...register('code', { required: 'Code is required' })}
                />
                {errors.code && (
                  <p className="mt-1 text-sm text-red-600">{errors.code.message}</p>
                )}
              </div>
              <div>
                <label className="form-label" htmlFor="new_password">New password</label>
                <input
                  id="new_password"
                  type="password"
                  className={`pl-4 form-input ${errors.new_password ? 'border-red-500' : ''}`}
                  placeholder="New password"
                  {...register('new_password', { required: 'New password is required' })}
                />
                {errors.new_password && (
                  <p className="mt-1 text-sm text-red-600">{errors.new_password.message}</p>
                )}
              </div>
            </div>
            <button type="submit" className="btn-primary w-full">Reset Password</button>
          </form>
        </div>
            <div className="text-centtext-center flex justify-center align-center drop-shadow-lger">
              <Link to="/login" className="text-blue-600 hover:text-blue-500 text-sm">
                <CornerDownLeft color='black' size={40}/>
              </Link>
            </div>
      </div>
    </div>
  );
};

export default ResetPassword;


